import { render, staticRenderFns } from "./ClientCMSProductRevision.vue?vue&type=template&id=34ef73cf&scoped=true&"
import script from "./ClientCMSProductRevision.vue?vue&type=script&lang=js&"
export * from "./ClientCMSProductRevision.vue?vue&type=script&lang=js&"
import style0 from "./ClientCMSProductRevision.vue?vue&type=style&index=0&id=34ef73cf&prod&lang=css&"
import style1 from "./ClientCMSProductRevision.vue?vue&type=style&index=1&id=34ef73cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef73cf",
  null
  
)

export default component.exports